import script from "./FaqTab.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqTab.vue?vue&type=script&setup=true&lang=js"

import "./FaqTab.vue?vue&type=style&index=0&id=73e61c31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e61c31"]])

export default __exports__